import { vec3 } from "gl-matrix";
import { MathConst } from "./wContants.js";
import { wMath } from "./wMath.js";

class wLine {
    constructor(p0, p1) {
        this.p0_ = p0 !== undefined ? p0 : vec3.fromValues(0.0, 0.0, 0.0);
        this.p1_ = p1 !== undefined ? p1 : vec3.fromValues(1.0, 1.0, 1.0);
    }

    setLine(p0, p1) {
        vec3.copy(this.p0_,p0);
        vec3.copy(this.p1_,p1);
    }

    setP0(p0) {
        vec3.copy(this.p0_,p0);
    }

    setP1(p1) {
        vec3.copy(this.p1_,p1);
    }

    p0() {
        let p = vec3.create();
        vec3.copy(p, this.p0_);
        return p;
    }

    p1() {
        let p = vec3.create();
        vec3.copy(p, this.p1_);
        return p;
    }

    getLength() {
        let tmp = vec3.create();
        vec3.subtract(tmp, this.p1_, this.p0_);
        return vec3.length(tmp);
    }

    closestLineDistanceToPoint(p) {
        const tp = wMath.vec3Sub(p, this.p0_);
        const Cs = vec3.dot(tp, tp);
        const pProj = wMath.vectorProjection(tp, this.getLineDirection());
        const Bs = vec3.dot(pProj, pProj);
        return Math.sqrt(Cs - Bs);
    }

    rayLineClosestDistance(ray) {
        const V1 = this.getLineDirection();  
        const V2 = ray.getDirection();
	    const S1 = this.p0();
	    const S2 = ray.getOrigin();

        let s2s1 = wMath.vec3Sub(S2,S1)
        let v1v2 = vec3.dot(V1, V2);
        let det = (v1v2 * v1v2) - 1.0;

        if (Math.abs(det) < MathConst.fEps2) {
            return [closestLineDistanceToPoint(S2), 0.0]; 
        }

        let invDet = 1.0 / det;
        let s2s1v1 = vec3.dot(s2s1, V1);
        let s2s1v2 = vec3.dot(s2s1, V2);

        let t1 = invDet * (-s2s1v1 + v1v2 * s2s1v2);
        let t2 = invDet * (-s2s1v1 * v1v2 + s2s1v2);

        let tmp = vec3.create();
       
        vec3.scale(tmp, V1, t1);
        let P1 = wMath.vec3Add(S1, tmp);

        vec3.scale(tmp, V2, t2);
        let P2 = wMath.vec3Add(S2, tmp);
    
        if (t1 < 0.0) {
            vec3.subtract(tmp, P2, this.p0_);
            return [vec3.length(tmp), t2];
        } else if (t1 > this.getLength()) {
            vec3.subtract(tmp, P2, this.p1_);
            return [vec3.length(tmp),t2];
        }
        vec3.subtract(tmp, P2, P1);
        return [vec3.length(tmp), t2];
    }

    getLineDirection() {
        let tmp = vec3.create();
        let dir = vec3.create();

        vec3.subtract(tmp, this.p1_, this.p0_);
        vec3.normalize(dir, tmp);

        return dir;
    }

    getPoint(t) {
        let p = vec3.create();
        let tmp1 = vec3.create();
        let tmp2 = vec3.create();

        vec3.subtract(tmp1, this.p1_, this.p0_);
        vec3.scale(tmp2, tmp1, t);
        vec3.add(p, this.p0_, tmp2);
        return p;
    }

    getPointProjection(p) {
        let dir = vec3.create();
        vec3.sub(dir, p, this.p0_);
        let n = this.getLineDirection();
        let dotProd = vec3.dot(dir, n);
        let tmp = vec3.create();
        let projVec = vec3.create();
        vec3.scale(tmp, n, dotProd);
        vec3.add(projVec, this.p0_, tmp);
        return projVec;
    }

    translate(t) {
        this.p0_[0] += t[0];
        this.p0_[1] += t[1];
        this.p0_[2] += t[2];

        this.p1_[0] += t[0];
        this.p1_[1] += t[1];
        this.p1_[2] += t[2];
    }
}
export { wLine };
